/* Tuckaway theme scripts. Small, vanilla, no dependencies. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = withCommas + '.' + parts[1];
    var noDec = withCommas;
    var commaAmount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return noDec;
        case 'amount_with_comma_separator': return commaAmount;
        case 'amount_no_decimals_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default: return amount;
      }
    });
    /* match money_without_trailing_zeros: $48.00 becomes $48 */
    return out.replace(/([.,])00(?!\d)/, '');
  }

  function stripTags(html) {
    var d = document.createElement('div');
    d.innerHTML = html;
    return d.textContent || '';
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var fmtEl = root.querySelector('[data-money-format]');
    var moneyFormat = fmtEl ? stripTags(JSON.parse(fmtEl.textContent)) : '${{amount}}';
    var fieldsets = root.querySelectorAll('[data-option-index]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add]');
    var priceAmt = root.querySelector('[data-price-amount]');
    var priceLabel = root.querySelector('[data-price-label]');
    var qtyInput = root.querySelector('[data-qty]');
    var addLabel = addBtn ? addBtn.textContent.split('·')[0].trim() : 'Add to bag';
    if (addBtn && addBtn.disabled) addLabel = 'Add to bag';
    var soldOutLabel = 'Sold out';

    function selected() {
      var vals = [];
      fieldsets.forEach(function (fs) {
        var on = fs.querySelector('.choice[aria-pressed="true"]');
        vals.push(on ? on.getAttribute('data-value') : null);
      });
      return vals;
    }

    function findVariant(vals) {
      return product.variants.find(function (v) {
        return vals.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function qty() {
      var q = parseInt(qtyInput && qtyInput.value, 10);
      return isNaN(q) || q < 1 ? 1 : q;
    }

    function update(pushUrl) {
      var vals = selected();
      var v = findVariant(vals);
      fieldsets.forEach(function (fs) {
        var on = fs.querySelector('.choice[aria-pressed="true"]');
        var note = fs.querySelector('[data-legend-note]');
        var legendText = fs.querySelector('legend').firstChild.textContent.trim().toLowerCase();
        if (note && legendText === 'size' && on) note.textContent = on.getAttribute('data-detail') || '';
      });
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceAmt) priceAmt.textContent = formatMoney(v.price, moneyFormat);
      if (priceLabel) priceLabel.textContent = v.options.join(' · ');
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addLabel + ' · ' + formatMoney(v.price * qty(), moneyFormat) : soldOutLabel;
      }
      /* size dependent bits */
      var size = v.options[0];
      var ar = size === 'Solo' ? '3/2' : size === 'Family' ? '5/4' : '4/3';
      var face = root.querySelector('[data-view-panel="open"] .face');
      if (face) face.style.setProperty('--ar', ar);
      root.querySelectorAll('[data-solo-only]').forEach(function (li) { li.hidden = size !== 'Solo'; });
      var specSize = root.querySelector('[data-spec-size]');
      var sizeBtn = fieldsets[0] && fieldsets[0].querySelector('.choice[aria-pressed="true"]');
      if (specSize && sizeBtn && sizeBtn.getAttribute('data-detail')) specSize.textContent = sizeBtn.getAttribute('data-detail');
      var specBuild = root.querySelector('[data-spec-build]');
      var buildBtn = fieldsets[1] && fieldsets[1].querySelector('.choice[aria-pressed="true"]');
      if (specBuild && buildBtn) {
        var d = buildBtn.getAttribute('data-detail');
        specBuild.textContent = buildBtn.getAttribute('data-value') + (d ? ': ' + d : '');
      }
      if (pushUrl && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        url.searchParams.delete('size');
        history.replaceState({}, '', url.toString());
      }
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('click', function (e) {
        var btn = e.target.closest('.choice');
        if (!btn) return;
        fs.querySelectorAll('.choice').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        update(true);
      });
    });

    root.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, Math.min(10, qty() + parseInt(b.getAttribute('data-qty-step'), 10)));
        qtyInput.value = n;
        update(false);
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { update(false); });

    /* gallery views */
    var thumbs = root.querySelectorAll('[data-view]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var view = t.getAttribute('data-view');
        thumbs.forEach(function (o) { o.setAttribute('aria-pressed', o === t ? 'true' : 'false'); });
        root.querySelectorAll('[data-view-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-view-panel') !== view; });
      });
    });

    /* ?size=Solo preselects a size (used by footer links) */
    var params = new URLSearchParams(window.location.search);
    var wantSize = params.get('size');
    if (wantSize && !params.get('variant') && fieldsets[0]) {
      var match = fieldsets[0].querySelector('.choice[data-value="' + wantSize.replace(/"/g, '') + '"]');
      if (match) {
        fieldsets[0].querySelectorAll('.choice').forEach(function (b) { b.setAttribute('aria-pressed', b === match ? 'true' : 'false'); });
      }
    }
    update(false);
  }

  /* ---------- cart page ---------- */
  function initCart(form) {
    var timer;
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line-step]');
      if (!b) return;
      var input = form.querySelector('#' + b.getAttribute('aria-controls'));
      if (!input) return;
      var n = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-line-step'), 10));
      input.value = n;
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 350);
    });
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[name="updates[]"]')) {
        clearTimeout(timer);
        timer = setTimeout(function () { form.submit(); }, 350);
      }
    });
    var upd = form.querySelector('[data-update-btn]');
    if (upd) upd.hidden = true;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('[data-product]').forEach(initProduct);
    document.querySelectorAll('[data-cart-form]').forEach(initCart);
  });
})();
